<template>
    <div v-if="detailInfo" style="height: 100%">
        <div v-if="analysisMethod === 'Trend' || analysisMethod === 'savingRate'" class="trendOutter">
            <div class="trendContainer">
                <div class="row m-0" style="height: 26rem">
                    <div class="col-4 p-0" style="display: flex; align-items: center">
                        <span class="badge mb-0" style="font-size: 12px; margin-right: 5px">{{ "분석 데이터" }}</span>
                        <span class="m-0">{{ `${targetInfo.name ?? "-"} (${targetInfo.ptIdx ?? "-"})` }}</span>
                    </div>
                    <CommonDoubleLineChartPanel
                        :detailInfo="detailInfo"
                        :resultData="resultData"
                        :chartResize="chartResize"
                        :calendarList="throwCalendarList"
                        :switchValues="switchValues"
                        :showToolbox="true"
                        :hideInfoPanel="hideInfoPanel"
                        @brush-end="handleTrendBrushEnd"
                        @brush-clear="calculateTrendTotal"
                        @show-evt-detail="showEventDetailModal"
                        @get-evt-detail="getEnergyCalendar"
                    />
                </div>

                <div class="compareResultTable">
                    <div class="tableHeader">
                        <div class="col-2 p-0">
                            <span class="badge mb-0" style="font-size: 12px; margin-right: 5px">
                                {{ "비교 데이터" }}
                            </span>
                        </div>
                        <div class="col-10 pr-0" style="display: flex; justify-content: flex-end">
                            <div class="col-4 input-group mt-2 mb-2 pr-0">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="target-data">{{ "선택 기간" }}</span>
                                </div>
                                <input
                                    type="text"
                                    class="form-control text-center"
                                    :value="
                                        fromChartSelectDate && toChartSelectDate
                                            ? `${fromChartSelectDate} ~ ${toChartSelectDate}`
                                            : '전체'
                                    "
                                    aria-describedby="target-data"
                                    disabled
                                />
                            </div>
                        </div>
                    </div>

                    <table class="table table-bordered text-center">
                        <thead class="thead-dark">
                            <tr>
                                <th scope="col" class="table-header-style">
                                    {{
                                        detailInfo.analysisMethod == "savingRate"
                                            ? "기준 데이터"
                                            : (targetInfo.name ?? "-")
                                    }}
                                </th>
                                <th scope="col" class="table-header-style">
                                    {{ detailInfo.analysisMethod == "savingRate" ? "비교 데이터" : compareType }}
                                </th>
                                <th scope="col" class="table-header-style">
                                    {{ detailInfo.analysisMethod == "savingRate" ? "에너지 절감량" : "증감량" }}
                                </th>
                                <th scope="col" style="font-weight: 100 !important">
                                    {{ detailInfo.analysisMethod == "savingRate" ? "에너지 절감률" : "증감률" }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td
                                    v-for="key in summedKeys"
                                    :key="`trend-${key}`"
                                    :style="{
                                        backgroundColor:
                                            key == 'main' || key == 'incDecAmount' || key == 'incDecPercent'
                                                ? '#ECEFF1'
                                                : '',
                                        height: '50px',
                                    }"
                                >
                                    <span class="m-0 table-value-style">
                                        {{
                                            `${formatNumWithComma(summedData[key])} ${
                                                key !== "incDecPercent" ? summedData["unit"] : "%"
                                            }`
                                        }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <trend-statistic-panel :resultData="resultData" :hideInfoPanel="hideInfoPanel" />
                <trend-heat-map-chart-panel-vue
                    :detailInfo="detailInfo"
                    :resultData="resultData"
                    :hideInfoPanel="hideInfoPanel"
                />
            </div>
        </div>
        <div v-else-if="analysisMethod === 'Diff'" style="height: 100%; width: 100%">
            <!-- chart -->
            <div class="row m-0" style="height: 25rem">
                <div class="col-4 p-0" style="display: flex; align-items: center">
                    <span class="badge mb-0" style="font-size: 12px; margin-right: 5px">{{ "분석 데이터" }}</span>
                    <span class="m-0">{{ `${targetInfo.name ?? "-"} (${targetInfo.ptIdx ?? "-"})` }}</span>
                </div>
                <CommonDoubleLineChartPanel
                    :detailInfo="detailInfo"
                    :resultData="resultData"
                    :chartResize="chartResize"
                    :calendarList="throwCalendarList"
                    :switchValues="switchValues"
                    :showToolbox="true"
                    :hideInfoPanel="hideInfoPanel"
                    @brush-end="handleDiffBrushEnd"
                    @brush-clear="calculateDiffTotal"
                    @show-evt-detail="showEventDetailModal"
                    @get-evt-detail="getEnergyCalendar"
                />
            </div>
            <div class="row m-0" style="margin: 2rem 0px 0px 0px !important; align-items: center">
                <div class="col-2 p-0">
                    <span class="badge mb-0" style="font-size: 12px; margin-right: 5px">{{ "비교 데이터" }}</span>
                </div>
                <div class="col-10 p-0" style="display: flex; justify-content: flex-end">
                    <div class="col-4 p-0 input-group mr-2">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="target-data">{{ "선택 기간" }}</span>
                        </div>
                        <input
                            type="text"
                            class="form-control text-center"
                            :value="
                                fromChartSelectDate && toChartSelectDate
                                    ? `${fromChartSelectDate} ~ ${toChartSelectDate}`
                                    : '전체'
                            "
                            aria-describedby="target-data"
                            disabled
                        />
                    </div>
                    <div class="col-2 p-0 input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="target-data">{{ "차트 표시수" }}</span>
                        </div>
                        <select v-model="chartDisp" class="form-control" name="" id="">
                            <option :value="1">{{ "1" }}</option>
                            <option :value="2">{{ "2" }}</option>
                            <option :value="3">{{ "3" }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row m-0">
                <div class="col-lg-12 p-0 mt-2 table-scroll-container">
                    <table class="table table-bordered text-center mnv-period-table-box">
                        <thead class="thead-dark">
                            <tr>
                                <th
                                    v-for="key in summedKeys"
                                    :key="key"
                                    scope="col"
                                    class="table-header-style"
                                    :style="{ backgroundColor: targetInfo.ptIdx == key ? '#ECEFF1' : '' }"
                                >
                                    {{ key }}
                                    <!-- {{
                                        resultData.headers.find((item) => item.key == key)
                                            ? resultData.headers.find((item) => item.key == key).ptName
                                            : key
                                    }} -->
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td
                                    v-for="key in summedKeys"
                                    :key="key"
                                    :style="{
                                        backgroundColor: targetInfo.ptIdx == key || key == targetPtKey ? '#ECEFF1' : '',
                                        height: '50px',
                                    }"
                                >
                                    <span class="m-0 table-value-style">
                                        {{ `${formatNumWithComma(summedData[key].value)} ${summedData[key].unit}` }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row m-0" style="height: 300px; margin: 2rem 0px 0px 0px !important">
                <div
                    v-for="(component, index) in diffChartData"
                    :key="component.header.ptIdx"
                    class="p-0"
                    style="height: 100%"
                    :class="chartDisp == 1 ? 'col-12' : chartDisp == 2 ? 'col-6' : 'col-4'"
                >
                    <CompareLineChartPanel
                        :detailInfo="detailInfo"
                        :chartData="component"
                        :chartDisp="chartDisp"
                        :chartResize="chartResize"
                        :chartIndex="index"
                        :hideInfoPanel="hideInfoPanel"
                        @hover-event="syncHoverEvent"
                        ref="charts"
                    />
                </div>
            </div>
        </div>
        <div v-else-if="analysisMethod === 'Comp'" style="height: 100%; width: 100%">
            <div class="row m-0" style="height: 25rem">
                <div class="col-4 p-0" style="display: flex; align-items: center">
                    <span class="badge mb-0" style="font-size: 12px; margin-right: 5px">{{ "분석 데이터" }}</span>
                    <span class="m-0">{{ `${targetInfo.name ?? "-"} (${targetInfo.ptIdx ?? "-"})` }}</span>
                </div>
                <CommonDoubleLineChartPanel
                    :detailInfo="detailInfo"
                    :resultData="resultData"
                    :chartResize="chartResize"
                    :calendarList="throwCalendarList"
                    :switchValues="switchValues"
                    :showToolbox="true"
                    :hideInfoPanel="hideInfoPanel"
                    @brush-end="handleCompBrushEnd"
                    @brush-clear="calculateCompTotal"
                    @show-evt-detail="showEventDetailModal"
                    @get-evt-detail="getEnergyCalendar"
                />
            </div>

            <!-- 성분 분석 -->
            <!-- table -->
            <div class="compResultTable">
                <div class="tableHeader">
                    <div class="col-2 p-0">
                        <!-- <h5 class="mb-0">{{ "" }}</h5> -->
                        <span class="badge mb-0" style="font-size: 12px; margin-right: 5px">{{ "구성 데이터" }}</span>
                    </div>
                    <div class="col-10 pr-0" style="display: flex; justify-content: flex-end">
                        <div class="col-4 input-group mt-2 mb-2 pr-0">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="target-data">{{ "선택 기간" }}</span>
                            </div>
                            <input
                                type="text"
                                class="form-control text-center"
                                :value="
                                    fromChartSelectDate && toChartSelectDate
                                        ? `${fromChartSelectDate} ~ ${toChartSelectDate}`
                                        : '전체'
                                "
                                aria-describedby="target-data"
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div class="compTable">
                    <div class="col-lg-12 p-0">
                        <table class="table table-bordered text-center">
                            <thead class="thead-dark">
                                <tr>
                                    <th
                                        v-for="key in summedKeys"
                                        :key="`comp-header-${key}`"
                                        scope="col"
                                        class="table-header-style"
                                    >
                                        {{ key || resultData.headers.find((item) => item.key == key).ptName || "-" }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        v-for="key in summedKeys"
                                        :key="`comp-body-${key}`"
                                        :style="{
                                            backgroundColor:
                                                targetInfo.ptIdx == key || key == 'total' || key == targetPtKey
                                                    ? '#ECEFF1'
                                                    : '',
                                            height: '45px',
                                        }"
                                    >
                                        <span class="m-0 table-value-style">
                                            {{
                                                `${formatNumWithComma(summedData[key].value)}
                                                ${summedData[key].unit ?? "-"}`
                                            }}
                                            <!-- {{ summedData[key] }} -->
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        v-for="key in summedKeys"
                                        :key="`comp-body-${key}`"
                                        :style="{
                                            backgroundColor:
                                                targetInfo.ptIdx == key || key == 'total' || key == targetPtKey
                                                    ? '#ECEFF1'
                                                    : '',
                                            height: '45px',
                                        }"
                                    >
                                        <span class="m-0 table-value-style">
                                            {{ `${summedData[key].percent} %` }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <!-- bottom stack and doughnut chart -->
            <div class="row m-0" style="height: 300px">
                <div style="width: 100%; height: 100%">
                    <CompStackChartPanel
                        :detailInfo="detailInfo"
                        :resultData="resultData"
                        :chartResize="chartResize"
                        :hideInfoPanel="hideInfoPanel"
                    />
                </div>
            </div>
        </div>

        <div v-else-if="analysisMethod === 'Reltn'" class="reltnContainer">
            <div class="reltnTitle">상관 분석 결과</div>
            <div class="reltnSummary">
                <div class="reltnSummaryTable">
                    <b-table-simple bordered class="text-center" style="margin-right: 5px">
                        <b-tbody>
                            <b-tr style="height: 10%">
                                <b-td class="tableStyle">모델식</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td class="formula align-middle">
                                    <katex-markdown :formula="equation"></katex-markdown>
                                    <katex-markdown-r-2 :R2AdjR2="R2AdjR2"></katex-markdown-r-2>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <b-table-simple bordered class="text-center" style="margin-right: 5px">
                        <b-tbody>
                            <b-tr>
                                <b-td class="tableStyle align-middle" style="width: 20%">R2</b-td>
                                <b-th class="align-middle" style="width: 30%">{{
                                    resultData?.regressionEvaluation?.R2 ?? "-"
                                }}</b-th>
                                <b-td class="tableStyle align-middle" style="width: 20%">보정 R2</b-td>
                                <b-th class="align-middle" style="width: 30%" colspan="2">{{
                                    resultData?.regressionEvaluation?.adjustedR2 ?? "-"
                                }}</b-th>
                            </b-tr>

                            <b-tr>
                                <b-td class="tableStyle align-middle"> 종속변수(Y) </b-td>
                                <b-th class="align-middle" colspan="4">{{ targetInfo.name ?? "" }} </b-th>
                            </b-tr>
                            <b-tr>
                                <b-td class="tableStyle align-middle">독립변수(X)</b-td>
                                <b-th class="align-middle">데이터</b-th>
                                <b-th class="align-middle">Coefficient</b-th>
                                <b-th class="align-middle">P-value</b-th>
                                <b-th class="align-middle"> VIF </b-th>
                            </b-tr>
                            <b-tr v-for="(item, i) in factorsInfo" :key="i">
                                <b-td class="tableStyle align-middle">X{{ i + 1 }}</b-td>
                                <!-- <b-th class="align-middle">{{ item.ptName }}</b-th> -->
                                <b-th class="align-middle">{{ item.key }}</b-th>
                                <b-th class="align-middle" v-if="resultData && resultData.regressionEvaluation">
                                    {{ resultData.regressionEvaluation.coefficients[i + 1] }}
                                </b-th>
                                <b-th class="align-middle" v-if="resultData && resultData.regressionEvaluation">
                                    {{ resultData.regressionEvaluation.pValues[i + 1] }}
                                </b-th>
                                <b-th class="align-middle" v-if="resultData && resultData.regressionEvaluation">
                                    {{ resultData.regressionEvaluation.vif[i] }}
                                </b-th>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <b-table-simple bordered>
                        <!-- <b-tbody>
                            <b-tr v-for="(item, i) in evalResult" :key="i">
                                {{ item }}
                            </b-tr>
                        </b-tbody> -->
                        <div class="markDownReport">
                            <markdown-it-vue :content="evalResult"></markdown-it-vue>
                        </div>
                    </b-table-simple>
                </div>
            </div>
            <div v-for="(item, i) in correlationData" :key="i" class="reltnBox">
                <div class="reltnTitle">vs {{ item.key }}</div>
                <div class="reltnBody d-flex">
                    <div class="chart-container" style="flex: 33%">
                        <div class="reltnChart">
                            <!-- <div class="reltnSubTitle">상관도 분석</div> -->
                            <ReltnScatterChartPanel
                                :detailInfo="detailInfo"
                                :resultData="resultData"
                                :chartResize="chartResize"
                                :corrData="item"
                                :hideInfoPanel="hideInfoPanel"
                            />
                        </div>
                    </div>
                    <div class="chart-container" style="flex: 25%">
                        <div class="reltnChart">
                            <!-- <div class="reltnSubTitle">시계열 추세 분석</div> -->
                            <div class="commonDoubleChartBox">
                                <CommonDoubleLineChartPanel
                                    :detailInfo="detailInfo"
                                    :resultData="resultData"
                                    :chartResize="chartResize"
                                    narrow="12%"
                                    :calendarList="throwCalendarList"
                                    :showToolbox="false"
                                    :hideInfoPanel="hideInfoPanel"
                                    showLineAndTick="true"
                                    invisibleLabel="true"
                                    topGrid="1"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="table-container">
                        <!-- <div class="equationContainer"></div> -->
                        <!-- <div class="reltnSubTitle">통계 지표 분석</div> -->
                        <div class="statisticButtonContainer">
                            <div class="statisticButtonBox">
                                <!-- <button
                                    class="col status-icon mr-1 analysisReportButton"
                                    :class="{ active: activeIcon === 'statisticReport' }"
                                    @click="handleIconClick('statisticReport')"
                                    :title="'통계지표'"
                                >
                                    <span>분석지표</span>
                                </button> -->
                                <button
                                    class="col status-icon analysisReportButton"
                                    @click="
                                        showAnalysisResultModal(
                                            item.variableEvaluation.equation,
                                            item.variableEvaluation.evalResult,
                                        )
                                    "
                                    :title="`분석결과 `"
                                >
                                    <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <div v-if="activeIcon === 'statisticReport'" style="flex: 1; overflow-y: auto">
                            <b-table-simple class="text-center anaylsisResultTable">
                                <b-tbody>
                                    <b-tr>
                                        <b-td
                                            :rowspan="item.variableEvaluation.coefficients.length + 1"
                                            class="align-middle"
                                            >회귀계수</b-td
                                        >
                                        <b-td>Y절편</b-td>
                                        <b-th>{{
                                            item.variableEvaluation.coefficients[0]
                                                ? item.variableEvaluation.coefficients[0]
                                                : 0
                                        }}</b-th>
                                    </b-tr>
                                    <b-tr
                                        v-for="(cfc, cfcIndex) in item.variableEvaluation.coefficients"
                                        :key="cfcIndex + 10"
                                    >
                                        <b-td v-if="cfcIndex !== 0">{{ `X${cfcIndex}계수` }}</b-td>
                                        <b-th v-if="cfcIndex !== 0">{{ cfc ? cfc : 0 }}</b-th>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{ "R2" }}</b-td>
                                        <b-th colspan="2">{{
                                            item.variableEvaluation.R2 ? item.variableEvaluation.R2 : 0
                                        }}</b-th>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{ "보정 R2" }}</b-td>
                                        <b-th colspan="2">{{
                                            item.variableEvaluation.adjustedR2 ? item.variableEvaluation.adjustedR2 : 0
                                        }}</b-th>
                                    </b-tr>
                                    <b-tr>
                                        <b-td :rowspan="item.variableEvaluation.pValues.length + 1" class="align-middle"
                                            >P-Value</b-td
                                        >
                                        <b-td>Y절편</b-td>
                                        <b-th>{{
                                            item.variableEvaluation.pValues[0] ? item.variableEvaluation.pValues[0] : 0
                                        }}</b-th>
                                    </b-tr>
                                    <b-tr
                                        v-for="(pVal, pValIndex) in item.variableEvaluation.pValues"
                                        :key="pValIndex + 20"
                                    >
                                        <b-td v-if="pValIndex !== 0">{{ `X${pValIndex}계수` }}</b-td>
                                        <b-th v-if="pValIndex !== 0">{{ pVal ? pVal : 0 }}</b-th>
                                    </b-tr>
                                    <b-tr>
                                        <b-td :rowspan="item.variableEvaluation.vif.length + 1">다중공선성</b-td>
                                        <b-td>X1</b-td>
                                        <b-th>{{
                                            item.variableEvaluation.vif[0] ? item.variableEvaluation.vif[0] : 0
                                        }}</b-th>
                                    </b-tr>
                                    <b-tr v-for="(vif, vifIndex) in item.variableEvaluation.vif" :key="vifIndex + 30">
                                        <b-td v-if="vifIndex !== 0">{{ `X${vifIndex + 1}` }}</b-td>
                                        <b-th v-if="vifIndex !== 0">{{ vif ? vif : 0 }}</b-th>
                                    </b-tr>
                                </b-tbody>
                            </b-table-simple>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="analysisMethod === 'Goal'" style="height: 100%; width: 100%">
            <div class="row m-0">
                <!-- waterfall chart -->
                <div class="col-12 p-0" style="height: 300px">
                    <!-- {{ "waterfall chart" }} -->
                    <GoalWaterFallChartPanel
                        :detailInfo="detailInfo"
                        :resultData="resultData"
                        :chartResize="chartResize"
                        :hideInfoPanel="hideInfoPanel"
                    />
                </div>
                <!-- table -->
                <div class="col-12 p-0">
                    <GoalResultTable :detailInfo="detailInfo" :resultData="resultData" />
                </div>
            </div>
        </div>
        <div v-else-if="analysisMethod === 'Cost'" style="height: 100%; width: 100%">
            {{ "비용 분석 결과" }}
        </div>
        <div v-else-if="detailInfo.analysisMethod === 'MNV'" style="height: 100%; width: 100%" class="mnvResultPanel">
            <mnv-result-panel
                class="mnvResultPanel"
                :detailInfo="detailInfo"
                :resultData="resultData"
                :adjustData="adjustData"
                :fixIndependData="fixIndependData"
                :mode="mode"
                @prop-mgmt-modal="showPropMgmtModal"
                ref="mnvResultPanel"
                :existMnvReportFlag="existMnvReportFlag"
                :reportMnvType="reportMnvType"
                @changeGenerateMnvReportType="changeGenerateMnvReportType"
                @activeTabMnvReport="activeTabMnvReport"
                @updateFactor="updateFactor"
                :mnvTab="mnvTab"
                @update:MnvTab="changeTab"
            ></mnv-result-panel>
        </div>
        <h4 v-else>{{ "no match analysis method" }}</h4>

        <b-modal ref="eventDetailModal" centered>
            <template #modal-header>
                <h5 class="mb-0">{{ "이벤트 상세" }}</h5>
            </template>
            <EventDetailModalPanel :eventDetail="eventDetail" />
            <template #modal-footer>
                <div style="display: flex; flex: 1">
                    <button
                        class="btn btn-sm btn-secondary"
                        style="flex: 1"
                        @click="() => $refs.eventDetailModal.hide()"
                    >
                        {{ "닫기" }}
                    </button>
                </div>
            </template>
        </b-modal>
        <b-modal ref="analysisResultModal" :title="`분석결과 (Y=${analysisModalTitle})`" hide-footer>
            <div class="markDownReport">
                <markdown-it-vue :content="individualContent"></markdown-it-vue>
            </div>
        </b-modal>
    </div>
</template>

<script>
import backEndApi from "@src/api/backEndApi";
import CommonDoubleLineChartPanel from "../charts/CommonDoubleLineChartPanel.vue";
import CompareLineChartPanel from "../charts/CompareLineChartPanel.vue";
//트렌드분석
import TrendStatisticPanel from "../charts/TrendStatisticPanel.vue";
import TrendHeatMapChartPanelVue from "../charts/TrendHeatMapChartPanel.vue";
// 성분 분석
import CompStackChartPanel from "../charts/CompStackChartPanel.vue";
// 상관분석
import ReltnScatterChartPanel from "../charts/ReltnScatterChartPanel.vue";
// 목표분석
import GoalWaterFallChartPanel from "../charts/GoalWaterFallChartPanel.vue";
import GoalResultTable from "../tables/GoalResultTable.vue";
// MNV 분석
import MnvResultPanel from "./MnvResultPanel.vue";

//마크다운
import KatexMarkdown from "@src/views/component/markdownComponent/KatexMarkdown.vue";
import KatexMarkdownR2 from "@src/views/component/markdownComponent/KatexMarkdownR2.vue";
import MarkdownItVue from "markdown-it-vue";
import "markdown-it-vue/dist/markdown-it-vue.css";
// import MarkdownItVue from "markdown-it-vue";
// import "markdown-it-vue/dist/markdown-it-vue.css";

import EventDetailModalPanel from "./EventDetailModalPanel.vue";

export default {
    props: [
        "detailInfo",
        "chartResize",
        "analysisMethod",
        "resultData",
        "calendarList",
        "switchValues",
        "adjustData",
        "fixIndependData",
        "mode",
        "existMnvReportFlag",
        "reportMnvType",
        "mnvTab",
        "hideInfoPanel",
        "targetPtName",
    ],
    components: {
        KatexMarkdown,
        KatexMarkdownR2,
        MarkdownItVue,
        TrendHeatMapChartPanelVue,
        // TrendLineChartPanel,
        TrendStatisticPanel,

        CommonDoubleLineChartPanel,
        CompareLineChartPanel,

        CompStackChartPanel,

        ReltnScatterChartPanel,

        GoalWaterFallChartPanel,
        GoalResultTable,

        EventDetailModalPanel,

        MnvResultPanel,
    },
    data() {
        return {
            // unit: this.resultData.headers[0].unitSmallCode,
            individualContent: "",
            analysisModalTitle: "",
            activeIcon: "statisticReport",
            chartDisp: 1,
            currentMonth: new Date().getMonth(),
            highlightingKeyword: ["Adjusted R", "회귀 계수", "p-value", "VIF"],
            yearTableData: null,

            // chart brush data fetching property
            brushData: null,
            fromChartSelectDate: null,
            toChartSelectDate: null,
            summedData: null,
            summedKeys: null,
            compPercent: null,

            eventDetail: null,
            compBrushDataCopy: {},
        };
    },
    computed: {
        targetPtKey() {
            const match = this.resultData.headers.find((item) => item.ptName === this.targetPtName);
            return match ? match.key : null;
        },
        R2AdjR2() {
            if (this.resultData.regressionEvaluation) {
                return [this.resultData.regressionEvaluation.R2, this.resultData.regressionEvaluation.adjustedR2];
            } else {
                return "데이터 없음";
            }
        },
        evalResult() {
            return this.resultData?.regressionEvaluation?.evalResult || "데이터 없음";
        },
        equation() {
            if (this.resultData?.regressionEvaluation?.equation) {
                return this.resultData.regressionEvaluation.equation;
            } else {
                return `데이터 없음`;
            }
        },
        factorsInfo() {
            if (!this.resultData || !this.resultData.variableEvaluation) return;
            const keys = Object.keys(this.resultData.variableEvaluation);

            const factorArr = this.resultData.headers.filter((item) => keys.includes(String(item.key)));
            return factorArr;
        },

        targetInfo() {
            return this.detailInfo.variables.find((item) => item.roleType === "Main") ?? null;
        },
        compareType() {
            const compareType = this.$store.state.commonCodes.compareType.find(
                (code) => code.value == this.detailInfo.compareType,
            );
            return compareType ? compareType.text : "비교 없음";
        },
        timeDsvn() {
            const dsvn = this.$store.state.commonCodes.timeDsvn.find((code) => code.value == this.detailInfo.timeDsvn);
            return dsvn ? dsvn.text : "";
        },

        // <비교분석> 성분 구성 차트 데이터
        diffChartData() {
            let data = [];
            const filterMainHeader = this.resultData.headers.find((item) => item.roleType == "Main");
            if (!this.isEmpty(filterMainHeader)) {
                data.push({
                    header: filterMainHeader ?? {},
                    value: this.resultData.values[filterMainHeader.key] ?? [],
                    regDt: this.resultData.values.regDt ?? [],
                });
            }
            const filterMemberPt = this.detailInfo.variables.filter((item) => item.roleType == "Compare");
            if (!this.isEmpty(filterMemberPt)) {
                const filterHeader = this.resultData.headers.filter((header) =>
                    filterMemberPt.some((mem) => header.ptIdx == mem.ptIdx),
                );
                filterHeader.forEach((filHeader) => {
                    data.push({
                        header: filHeader ?? {},
                        value: this.resultData.values[filHeader.key] ?? [],
                        regDt: this.resultData.values.regDt ?? [],
                    });
                });
            }
            return data;
        },
        //성분분석에서 필요한 데이터 유형들입니다.

        //성분 분석 에너지수급량입니다.
        sumBaseComponentEnergy() {
            const relevantHeaders = [
                this.resultData.headers.find((item) => item.ptIdx === String(this.targetInfo.ptIdx)),
                // ...this.resultData.headers.filter((item) => item.role === "Member"),
            ].filter(Boolean);

            const sumVal = relevantHeaders.reduce((acc, item) => {
                const ptIdx = item.ptIdx;
                if (this.resultData.values[ptIdx]) {
                    const arraySum = this.resultData.values[ptIdx].reduce((sum, value) => sum + value, 0);
                    return acc + arraySum;
                }
                return acc;
            }, 0);

            return sumVal.toFixed(2);
        },
        //성분분석에서 "합계" col 값입니다.
        sumCompComponentEnergy() {
            const result = new Map();

            // 관련 헤더 필터링
            const relevantHeaders = [
                ...this.resultData.headers.filter((item) => item.roleType === "Componenet"),
            ].filter(Boolean);

            // 헤더에 해당하는 데이터를 합산하여 Map에 저장
            relevantHeaders.forEach((item) => {
                const ptIdx = item.ptIdx;
                const sum = this.resultData.values[ptIdx]?.reduce((acc, value) => acc + value, 0) || 0;
                result.set(ptIdx, sum);
            });

            // Map 순회하며 모든 값을 더하기
            const totalSum = Array.from(result.values()).reduce((acc, value) => acc + value, 0);

            return totalSum; // 최종 합계 반환
        },
        //성분 분석에서 테이블 데이터 생성함수입니다.
        sumComponentEnergyEach() {
            const result = new Map();

            const relevantHeaders = [...this.resultData.headers.filter((item) => item.roleType === "Component")].filter(
                Boolean,
            );

            relevantHeaders.forEach((item) => {
                const ptIdx = item.ptIdx;
                const sum = this.resultData.values[ptIdx]?.reduce((acc, value) => acc + value, 0) || 0;
                result.set(ptIdx, sum);
            });

            const matchResult = relevantHeaders.map((item) => ({
                ptName: item.ptName,
                value: result.get(item.ptIdx) || 0,
            }));

            return matchResult;
        },

        //  상관 분석 데이터셋입니다.
        correlationData() {
            if (!this.resultData.variableEvaluation) return;
            let corrArr = [];
            const baseItem = this.resultData?.headers.find((item) => item.roleType === "Main");
            if (!baseItem) {
                console.error("Base item with role 'Main' not found.");
                return [];
            }

            const resultDataForCorr = this.resultData.headers.filter((item) => item.roleType === "Influence");

            for (const item of resultDataForCorr) {
                const innerCorr = [];
                const baseValues = this.resultData.values[baseItem.key];
                const itemValues = this.resultData.values[item.key];

                if (!baseValues || !itemValues) {
                    console.error(`Values not found for ptIdx: ${item.key}`);
                    continue;
                }

                const length = Math.min(baseValues.length, itemValues.length);
                for (let inner = 0; inner < length; inner++) {
                    innerCorr.push([itemValues[inner], baseValues[inner]]);
                }

                const additionalData = {
                    ptName: item.ptName,
                    // role: item.role,
                    ptIdx: item.ptIdx,
                    key: item.key,
                    unit: item.unitSmallCode,
                    variableEvaluation: this.resultData?.variableEvaluation[item.key],
                    correlation: innerCorr,
                };

                corrArr.push(additionalData);
            }

            return corrArr;
        },
        throwCalendarList() {
            return this.calendarList || [];
        },
    },
    watch: {
        resultData: {
            immediate: true,
            async handler(newVal) {
                if (newVal) {
                    if (this.detailInfo.analysisMethod == "Trend" || this.detailInfo.analysisMethod == "savingRate") {
                        await this.processData(newVal);
                        await this.calculateTrendTotal(newVal);
                    }
                    if (this.detailInfo.analysisMethod == "Diff") {
                        await this.processData(newVal);
                        await this.calculateDiffTotal(newVal);
                    }
                    if (this.detailInfo.analysisMethod == "Comp") {
                        await this.processData(newVal);
                        await this.calculateCompTotal(newVal);
                    }
                }
            },
        },
    },
    created() {},
    mounted() {},
    methods: {
        changeTab(bool) {
            this.$emit("update:MnvTab", bool);
        },
        updateFactor(factor, key) {
            this.$emit("updateFactor", factor, key);
        },
        activeTabMnvReport() {
            this.$emit("activeTabMnvReport");
        },
        changeGenerateMnvReportType(type) {
            this.$emit("changeGenerateMnvReportType", type);
        },
        showAnalysisResultModal(moddalTitle, content) {
            this.$refs.analysisResultModal.show();
            this.analysisModalTitle = moddalTitle;
            this.individualContent = content;
        },
        showPropMgmtModal() {
            this.$emit("show-property-management-modal");
        },
        syncHoverEvent({ index, event }) {
            // index와 event 객체를 처리
            this.hoverEvent = event;
            this.$refs.charts.forEach((chart, i) => {
                if (i !== index) {
                    chart.applyHoverEvent(event); // 다른 차트에도 이벤트 전달
                }
            });
        },

        formattingNumber(val) {
            return Number(val).toLocaleString();
        },
        handleIconClick(icon) {
            this.activeIcon = icon;
        },
        highlightedText(text) {
            const keywordPattern = this.highlightingKeyword.join("|");
            const regex = new RegExp(`(${keywordPattern})`, "gi");
            return text.replace(regex, '<span class="highlightMsg">$1</span>');
        },
        processData(data) {
            // Step 1: Identify `Reltn` roles
            const reltnKeys = data.headers
                .filter((header) => header.roleType === "Influence")
                .map((header) => header.ptIdx);

            // Step 2: Filter `values` keys
            const filteredValues = Object.keys(data.values)
                .filter((key) => !reltnKeys.includes(key))
                .reduce((acc, key) => {
                    acc[key] = data.values[key];
                    return acc;
                }, {});
            this.brushData = filteredValues;
        },
        async handleTrendBrushEnd(event) {
            const brushed = event.areas[0];
            this.fromChartSelectDate = this.resultData.values.regDt[brushed.coordRange[0]];
            this.toChartSelectDate = this.resultData.values.regDt[brushed.coordRange[1]];
            const findHeader = this.resultData.headers.find((item) => item.ptIdx == this.targetInfo.ptIdx);

            const { coordRange } = brushed;
            const startIdx = Math.round(coordRange[0]);
            const endIdx = Math.round(coordRange[1]);
            const mainData = this.brushData[findHeader.key].slice(startIdx, endIdx + 1);
            const compareData = this.resultData.comparison
                ? this.resultData.comparison[findHeader.key].value.slice(startIdx, endIdx + 1)
                : [];

            let ptTypeCode;
            let findUnit;
            let unit;
            if (!this.isEmpty(findHeader)) {
                ptTypeCode = findHeader.ptTypeCode ?? "SUM";
                findUnit = this.$store.state.units.find((item) => item.value == findHeader.unitSmallCode);
                unit = findHeader.dispUnit ? findHeader.dispUnit : findUnit ? findUnit.text : "-";
            }

            const summaryData = {
                main: null,
                compare: null,
                incDecAmount: null,
                incDecPercent: null,
                unit: unit,
            };

            if (!this.isEmpty(mainData)) {
                if (ptTypeCode == "SUM") {
                    summaryData.main = mainData.reduce((sum, value) => sum + (value || 0), 0).toFixed(1);
                    summaryData.compare = !this.isEmpty(compareData)
                        ? compareData.reduce((sum, value) => sum + (value || 0), 0).toFixed(1)
                        : 0;
                    summaryData.incDecAmount = (summaryData.main - summaryData.compare).toFixed(1);
                    // summaryData.incDecPercent = (
                    //     ((summaryData.compare - summaryData.main) / summaryData.main) *
                    //     100
                    // ).toFixed(1);
                    summaryData.incDecPercent = this.calcPercent(summaryData.main, summaryData.compare).toFixed(1);
                } else if (ptTypeCode == "AVG") {
                    summaryData.main = mainData.reduce((sum, value) => sum + (value || 0), 0) / mainData.length;
                    summaryData.compare = !this.isEmpty(compareData)
                        ? compareData.reduce((sum, value) => sum + (value || 0), 0) / compareData.length
                        : 0;
                    summaryData.incDecAmount = (summaryData.main - summaryData.compare).toFixed(1);
                    // summaryData.incDecPercent = (
                    //     ((summaryData.compare - summaryData.main) / summaryData.main) *
                    //     100
                    // ).toFixed(1);
                    summaryData.incDecPercent = this.calcPercent(summaryData.main, summaryData.compare).toFixed(1);
                } else if (ptTypeCode == "LST") {
                    summaryData.main = summaryData.mainData[summaryData.mainData.length - 1];
                    summaryData.compare = !this.isEmpty(compareData)
                        ? summaryData.compareData[summaryData.compareData.length - 1]
                        : 0;
                    summaryData.incDecAmount = (summaryData.main - summaryData.compare).toFixed(1);
                    // summaryData.incDecPercent = (
                    //     ((summaryData.compare - summaryData.main) / summaryData.main) *
                    //     100
                    // ).toFixed(1);
                    summaryData.incDecPercent = this.calcPercent(summaryData.main, summaryData.compare).toFixed(1);
                } else if (ptTypeCode == "MAX") {
                    summaryData.main = Math.max(...mainData);
                    summaryData.compare = !this.isEmpty(compareData) ? Math.max(...compareData) : 0;
                    summaryData.incDecAmount = (summaryData.main - summaryData.compare).toFixed(1);
                    // summaryData.incDecPercent = (
                    //     ((summaryData.compare - summaryData.main) / summaryData.main) *
                    //     100
                    // ).toFixed(1);
                    summaryData.incDecPercent = this.calcPercent(summaryData.main, summaryData.compare).toFixed(1);
                } else return;
            }
            this.summedData = summaryData;
        },
        calcPercent(now, prev) {
            if (this.detailInfo.analysisMethod == "savingRate") {
                return ((now - prev) / now) * 100;
            } else {
                return ((now - prev) / prev) * 100;
            }
        },
        async calculateTrendTotal() {
            this.fromChartSelectDate = null;
            this.toChartSelectDate = null;
            const findHeader = this.resultData.headers.find((item) => item.ptIdx == this.targetInfo.ptIdx);
            const mainData = this.brushData[findHeader.key];

            const compareData = !this.isEmpty(this.resultData.comparison)
                ? this.resultData.comparison[findHeader.key].value
                : [];

            let ptTypeCode;
            let findUnit;
            let unit;
            if (!this.isEmpty(findHeader)) {
                // ptTypeCode = findHeader.ptTypeCode ?? "SUM";
                if (!this.isEmpty(findHeader.ptTypeCode)) {
                    if (findHeader.ptAddr.includes("SELF")) ptTypeCode = "AVG";
                    else ptTypeCode = findHeader.ptTypeCode;
                } else ptTypeCode = "SUM";
                findUnit = this.$store.state.units.find((item) => item.value == findHeader.unitSmallCode);
                unit = findHeader.dispUnit ? findHeader.dispUnit : findUnit ? findUnit.text : "-";
            }
            let total = {
                main: null,
                compare: null,
                incDecAmount: null,
                incDecPercent: null,
                unit: unit,
            };
            if (!this.isEmpty(mainData)) {
                if (ptTypeCode == "SUM") {
                    total.main = mainData.reduce((sum, value) => sum + (value || 0), 0).toFixed(1);
                    total.compare = !this.isEmpty(compareData)
                        ? compareData.reduce((sum, value) => sum + (value || 0), 0).toFixed(1)
                        : 0;
                    total.incDecAmount = (total.main - total.compare).toFixed(1);
                    // total.incDecPercent = (((total.compare - total.main) / total.main) * 100).toFixed(1);
                    total.incDecPercent = this.calcPercent(total.main, total.compare).toFixed(1);
                } else if (ptTypeCode == "AVG") {
                    total.main = mainData.reduce((sum, value) => sum + (value || 0), 0) / mainData.length;
                    total.compare = !this.isEmpty(compareData)
                        ? compareData.reduce((sum, value) => sum + (value || 0), 0) / compareData.length
                        : 0;
                    total.incDecAmount = (total.main - total.compare).toFixed(1);
                    // total.incDecPercent = (((total.compare - total.main) / total.main) * 100).toFixed(1);
                    total.incDecPercent = this.calcPercent(total.main, total.compare).toFixed(1);
                } else if (ptTypeCode == "LST") {
                    total.main = total.mainData[total.mainData.length - 1];
                    total.compare = !this.isEmpty(compareData) ? total.compareData[total.compareData.length - 1] : 0;
                    total.incDecAmount = (total.main - total.compare).toFixed(1);
                    // total.incDecPercent = (((total.compare - total.main) / total.main) * 100).toFixed(1);
                    total.incDecPercent = this.calcPercent(total.main, total.compare).toFixed(1);
                } else if (ptTypeCode == "MAX") {
                    total.main = Math.max(...mainData);
                    total.compare = !this.isEmpty(compareData) ? Math.max(...compareData) : 0;
                    total.incDecAmount = (total.main - total.compare).toFixed(1);
                    // total.incDecPercent = (((total.compare - total.main) / total.main) * 100).toFixed(1);
                    total.incDecPercent = this.calcPercent(total.main, total.compare).toFixed(1);
                } else return;
            }
            this.summedData = total;
            this.summedKeys = Object.keys(this.summedData).filter((fil) => fil !== "unit");
        },
        async handleDiffBrushEnd(event) {
            const brushed = event.areas[0];
            this.fromChartSelectDate = this.resultData.values.regDt[brushed.coordRange[0]];
            this.toChartSelectDate = this.resultData.values.regDt[brushed.coordRange[1]];

            const { coordRange } = brushed;
            const startIdx = Math.round(coordRange[0]);
            const endIdx = Math.round(coordRange[1]);
            const summaryData = {};

            Object.keys(this.brushData).forEach((key) => {
                if (key !== "regDt") {
                    const findHeader = this.resultData.headers.find((item) => item.key == key);
                    let ptTypeCode;
                    let findUnit;
                    let unit;
                    if (!this.isEmpty(findHeader)) {
                        ptTypeCode = findHeader.ptTypeCode ?? "SUM";
                        findUnit = this.$store.state.units.find((item) => item.value == findHeader.unitSmallCode);
                        unit = findHeader.dispUnit ? findHeader.dispUnit : findUnit ? findUnit.text : "-";
                    }
                    const selectedValues = this.brushData[key].slice(startIdx, endIdx + 1);
                    summaryData[key] = {};
                    if (ptTypeCode == "SUM") {
                        summaryData[key].value = selectedValues.reduce((sum, value) => sum + (value || 0), 0);
                        summaryData[key].unit = unit;
                    } else if (ptTypeCode == "AVG") {
                        summaryData[key].value =
                            selectedValues.reduce((sum, value) => sum + (value || 0), 0) / selectedValues.length;
                        summaryData[key].unit = unit;
                    } else if (ptTypeCode == "LST") {
                        summaryData[key].value = selectedValues[selectedValues.length - 1];
                        summaryData[key].unit = unit;
                    } else if (ptTypeCode == "MAX") {
                        summaryData[key].value = Math.max(...selectedValues);
                        summaryData[key].unit = unit;
                    } else return;
                }
            });

            this.summedData = summaryData;
        },
        async calculateDiffTotal() {
            this.fromChartSelectDate = null;
            this.toChartSelectDate = null;

            const filteredHeaders = this.resultData.headers
                .filter((header) => header.roleType === "Main" || header.roleType === "Compare")
                .sort((a, b) => (a.roleType === "Main" ? 1 : b.roleType === "Main" ? -1 : 0));

            const totalSum = {};

            filteredHeaders.forEach((header) => {
                const key = header.key;

                if (this.brushData[key]) {
                    totalSum[key] = {};

                    const ptTypeCode = header.ptTypeCode ?? "SUM";
                    const findUnit = this.$store.state.units.find((item) => item.value === header.unitSmallCode);
                    const unit = header.dispUnit ? header.dispUnit : findUnit ? findUnit.text : "-";

                    if (ptTypeCode === "SUM") {
                        totalSum[key].value = this.brushData[key].reduce((sum, value) => sum + (value || 0), 0);
                        totalSum[key].unit = unit;
                    } else if (ptTypeCode === "AVG") {
                        totalSum[key].value =
                            this.brushData[key].reduce((sum, value) => sum + (value || 0), 0) /
                            this.brushData[key].length;
                        totalSum[key].unit = unit;
                    } else if (ptTypeCode === "LST") {
                        totalSum[key].value = this.brushData[key][this.brushData[key].length - 1];
                        totalSum[key].unit = unit;
                    } else if (ptTypeCode === "MAX") {
                        totalSum[key].value = Math.max(...this.brushData[key]);
                        totalSum[key].unit = unit;
                    }
                }
            });

            this.summedData = totalSum;
            this.summedKeys = Object.keys(this.summedData);
        },
        async handleCompBrushEnd(event) {
            const brushed = event.areas[0];
            this.fromChartSelectDate = this.resultData.values.regDt[brushed.coordRange[0]];
            this.toChartSelectDate = this.resultData.values.regDt[brushed.coordRange[1]];

            const header = this.resultData.headers.find((header) => header.ptIdx == this.targetInfo.ptIdx);
            let findUnit;
            let unit;
            if (!this.isEmpty(header)) {
                findUnit = this.$store.state.units.find((unit) => unit.value == header.unitSmallCode);
                unit = header.dispUnit ? header.dispUnit : findUnit ? findUnit.text : "-";
            }

            const { coordRange } = brushed;
            const startIdx = Math.round(coordRange[0]);
            const endIdx = Math.round(coordRange[1]);
            const summaryData = {};

            Object.keys(this.brushData).forEach((key) => {
                if (key !== "regDt") {
                    const findHeader = this.resultData.headers.find((item) => item.key == key);
                    let ptTypeCode;
                    let findUnit;
                    let unit;
                    if (!this.isEmpty(findHeader)) {
                        ptTypeCode = findHeader.ptTypeCode ?? "SUM";
                        findUnit = this.$store.state.units.find((item) => item.value == findHeader.unitSmallCode);
                        unit = findHeader.dispUnit ? findHeader.dispUnit : findUnit ? findUnit.text : "-";
                    }
                    const selectedValues = this.brushData[key].slice(startIdx, endIdx + 1);
                    summaryData[key] = {};
                    if (ptTypeCode == "SUM") {
                        summaryData[key].value = selectedValues.reduce((sum, value) => sum + (value || 0), 0);
                        summaryData[key].unit = unit;
                    } else if (ptTypeCode == "AVG") {
                        summaryData[key].value =
                            selectedValues.reduce((sum, value) => sum + (value || 0), 0) / selectedValues.length;
                        summaryData[key].unit = unit;
                    } else if (ptTypeCode == "LST") {
                        summaryData[key].value = selectedValues[selectedValues.length - 1];
                        summaryData[key].unit = unit;
                    } else if (ptTypeCode == "MAX") {
                        summaryData[key].value = Math.max(...selectedValues);
                        summaryData[key].unit = unit;
                    } else return;

                    if (this.targetInfo.ptIdx == findHeader.ptIdx) summaryData[key].type = "main";
                    else summaryData[key].type = "comp";
                }
            });
            summaryData.total = {
                value: Object.keys(summaryData)
                    .filter((key) => summaryData[key].type !== "main" && summaryData[key].value !== undefined)
                    .reduce((sum, key) => sum + (summaryData[key].value || 0), 0),
                unit: unit,
                type: "total",
            };

            const mainValue = Object.values(summaryData).find((item) => item.type === "main")?.value || 0;
            const totalValue = summaryData.total.value || 0;

            Object.keys(summaryData).forEach((key) => {
                if (summaryData[key].type === "main") {
                    summaryData[key].percent = 100;
                } else if (summaryData[key].type === "total") {
                    summaryData[key].percent = mainValue ? ((totalValue / mainValue) * 100).toFixed(2) : 0;
                } else {
                    summaryData[key].percent = totalValue
                        ? ((summaryData[key].value / totalValue) * 100).toFixed(2)
                        : 0;
                }
            });

            this.summedData = summaryData;
        },
        async calculateCompTotal() {
            this.fromChartSelectDate = null;
            this.toChartSelectDate = null;

            const components = this.detailInfo.variables.filter((item) => item.roleType === "Component");
            const mainItems = this.detailInfo.variables.filter((item) => item.roleType === "Main");

            const compNameList = [...components.map((item) => item.name), ...mainItems.map((item) => item.name)];

            const totalSum = {};
            let findUnit;
            let unit;

            Object.keys(this.brushData).forEach((key) => {
                if (key !== "regDt") {
                    totalSum[key] = this.brushData[key].reduce((sum, value) => sum + (value || 0), 0);

                    const findHeader = this.resultData.headers.find((item) => item.key == key);
                    let ptTypeCode;

                    if (findHeader) {
                        ptTypeCode = findHeader.ptTypeCode ?? "SUM";
                        findUnit = this.$store.state.units.find((item) => item.value === findHeader.unitSmallCode);
                        unit = findHeader.dispUnit ? findHeader.dispUnit : findUnit ? findUnit.text : "-";

                        totalSum[key] = {};

                        if (ptTypeCode === "SUM") {
                            totalSum[key].value = this.brushData[key].reduce((sum, value) => sum + (value || 0), 0);
                            totalSum[key].unit = unit;
                        } else if (ptTypeCode === "AVG") {
                            totalSum[key].value =
                                this.brushData[key].reduce((sum, value) => sum + (value || 0), 0) /
                                this.brushData[key].length;
                            totalSum[key].unit = unit;
                        } else if (ptTypeCode === "LST") {
                            totalSum[key].value = this.brushData[key][this.brushData[key].length - 1];
                            totalSum[key].unit = unit;
                        } else if (ptTypeCode === "MAX") {
                            totalSum[key].value = Math.max(...this.brushData[key]);
                            totalSum[key].unit = unit;
                        }
                    }

                    const mainHeader = this.resultData.headers.find((header) => header.roleType === "Main");
                    if (mainHeader && mainHeader.key === key) {
                        totalSum[key].type = "main";
                    } else if (findHeader && findHeader.roleType === "Component") {
                        totalSum[key].type = "comp";
                    }
                }
            });

            totalSum.total = {
                value: Object.keys(totalSum)
                    .filter((key) => totalSum[key].type !== "main" && totalSum[key].value !== undefined)
                    .reduce((sum, key) => sum + (totalSum[key].value || 0), 0),
                unit: unit,
                type: "total",
            };

            const mainValue = Object.values(totalSum).find((item) => item.type === "main")?.value || 0;
            const totalValue = totalSum.total.value || 0;

            Object.keys(totalSum).forEach((key) => {
                if (totalSum[key].type === "main") {
                    totalSum[key].percent = 100;
                } else if (totalSum[key].type === "total") {
                    totalSum[key].percent = mainValue ? ((totalValue / mainValue) * 100).toFixed(2) : 0;
                } else {
                    totalSum[key].percent = totalValue ? ((totalSum[key].value / totalValue) * 100).toFixed(2) : 0;
                }
            });

            this.summedData = Object.keys(totalSum)
                .filter((key) => compNameList.includes(key))
                .reduce((acc, key) => {
                    acc[key] = totalSum[key];
                    return acc;
                }, {});
            this.summedKeys = Object.keys(this.summedData);
        },
        formatNumWithComma(value) {
            let formatValue;

            if (!isNaN(value)) {
                formatValue =
                    typeof value == "number"
                        ? Number(value.toFixed(1))._comma()
                        : Number(Number(value).toFixed(1))._comma();
            } else {
                formatValue = value;
            }
            return formatValue;
        },
        showEventDetailModal() {
            this.$refs.eventDetailModal.show();
        },
        async getEnergyCalendar(id) {
            try {
                let result = await backEndApi.analysisModel.getEnergyCalendar(id);
                if (result.status == 200) this.eventDetail = result.data;
                else this.alertNoti(`${result.data.message}`);
            } catch (e) {
                console.error(e);
            }
        },
    },
};
</script>

<style scoped>
.mnvResultPanel {
    font-size: 12px;
}
.markDownReport {
    padding: 10px 15px;
}
.tableHeader {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.formula {
    font-size: 15px;
    font-weight: bold;
}
.reltnSummary {
    box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;
    padding: 5px 15px;
    border-radius: 15px;
    background-color: white;
}
.reltnSummaryTable {
    display: flex;
    margin-top: 10px;
}
.tableStyle {
    background-color: #eeeeee;
}
.customTableDanger {
    background-color: #ffe4e6;
}
.customTableWarning {
    background-color: #fffacd;
}
.customTableInfo {
    background-color: #e0ffff;
}
.reltnTitle {
    font-weight: 900;
    padding: 5px;
    font-size: 14px;
}
.reltnBody {
    height: 100%;
    display: flex;
    gap: 20px; /* 차트와 차트 사이의 간격을 20px로 설정 */
}

.reltnContainer {
    height: 100%;
    width: 100%;
    display: flex; /* Flex 컨테이너로 설정 */
    flex-direction: column; /* 수직 정렬 */
    gap: 10px; /* 박스 간격 */
}
.reltnBox {
    /* flex: 1;  */
    width: 100%;
    height: 20rem;
    margin: 1rem 0;
    /* padding: 0px 10px 15px 10px; */
    border-radius: 15px;
    display: flex; /* 내부 콘텐츠 정렬용 */
    flex-direction: column; /* 수직 콘텐츠 정렬 */
}
.reltnChart {
    width: 100%;
    height: 100%;
    box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff !important;
}
.reltnSubTitle {
    font-size: 13px;
    font-weight: 900;
    color: #bdbdbd;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    padding: 6px 7px;
    margin-bottom: 5px;
}
.compareResultTable .table {
    margin-bottom: 0;
}
.trendOutter {
    height: 100%;
}
.trendContainer {
    width: 100%;
    height: 100%;
}
.compareResultTable {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    margin-top: 2rem;
}
.compResultTable {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    margin-top: 2rem;
}
.compTable {
    display: flex;
}
.commonDoubleChartBox {
    height: 100%;
    width: 100%;
}
.equationContainer {
    display: flex;
    justify-content: center;
    background-color: #e4e7ea;
    font-weight: bolder;
    /* font-size: 10px; */
    /* color: yellow; */
    /* border-radius: 5px; */
    height: 36px;
    padding: 3px 5px;
    font-weight: 600;
    overflow-y: auto;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
}
.statisticButtonContainer {
    display: flex;
    width: 100%;
    justify-content: flex-end;
}
.statisticButtonBox {
    width: 20px;
    display: flex;
    justify-content: center;
}
/* .analysisReportButton {
    border-radius: 35px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
} */

.table-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 5px 6px;
    border-radius: 15px;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;
}
.status-icon {
    border-radius: 35px;

    color: #555;
    background-color: #fff;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.2rem;
    transition: background-color 0.5s;
}

.status-icon:hover {
    background-color: #c7c7c7;
}

.status-icon.active {
    color: #fff;
    background-color: #555;
}
.status-icon:focus,
.status-icon:active {
    outline: none;
    box-shadow: none;
}
.chart-container {
    /* flex: 1; */
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    box-shadow: rgba(0, 0, 0, 0.09) 0px 3px 12px;
    background-color: #ffffff;
}
.msgBox {
    margin-top: 4px;
    padding: 4px;
    border-radius: 5px;
    overflow-y: auto;
    height: 100%;
    max-height: 250px;
    box-sizing: border-box;
}
.table-header-style {
    font-weight: 100 !important;
}

.table-value-style {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-weight: bold;
    font-size: 13px;
}

.table-scroll-container {
    overflow-x: auto;
    width: 100%;
    display: block;
}

.mnv-period-table-box {
    width: max-content; /* 테이블이 콘텐츠 크기만큼 확장 */
    min-width: 100%; /* 테이블이 최소 너비를 가짐 */
    margin-bottom: 0px;
}
.anaylsisResultTable {
    margin-top: 10px;
    height: 90%;
}
</style>
